import { createContext } from "react";

import { CardSize } from "./types";

type CardContextValue = {
  size: CardSize;
};

export const CardContext = createContext<CardContextValue>({ size: "medium" });
